module.exports = __webpack_public_path__ + "static/media/ai-summary.2ef236ef.svg";